import './hibuSelect.scss';
import Select, {components, InputActionMeta} from 'react-select';
import React from 'react';
import {Option, SelectOnChange} from './select';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import classNames from 'clsx';

export type InputProps = {
    className?: string;
    id?: string;
    name?: string;
    onChange?: SelectOnChange;
    onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
    value?: Option;
    options?: Option[];
    isSearchable?: boolean;
    placeholder?: string;
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <SvgIcon icon={Icons.CHEVRON_DOWN}/>
        </components.DropdownIndicator>
    );
};

export const HibuSelect = React.memo((props: InputProps) => {
    return (
        <>
            <Select
                className={classNames('react-select--inline', props.className)}
                classNamePrefix={'react-select'}
                components={{DropdownIndicator}}
                id={props.id}
                name={props.name}
                onChange={props.onChange}
                value={props.value}
                options={props.options}
                isSearchable={props.isSearchable}
                placeholder={props.placeholder}
                onInputChange={props.onInputChange}
            />
        </>
    );
});
